import React from 'react';
import { Card } from '../components/UI/Card';
import { Button } from '../components/UI/Button';
import { Link } from 'react-router-dom';
interface FAQProps {
  openRegistrationForm?: () => void;
}
export const FAQ = ({
  openRegistrationForm
}: FAQProps) => {
  const faqSections = [{
    title: '🌍 For Visitors',
    questions: [{
      question: 'What is The Networking Salon?',
      answer: 'The Networking Salon is a community designed for culture shapers, leaders, influencers, and professionals who want to grow, collaborate, and make meaningful connections. We provide resources, curated opportunities, and interactive spaces to build authentic networks.'
    }, {
      question: 'Who can join the community?',
      answer: "Our community is open to professionals, entrepreneurs, creatives, and leaders who are curious, impact-driven, and ready to collaborate. Whether you're just starting out or already established, you'll find tools, peers, and opportunities to grow."
    }, {
      question: 'Is the community free to join?',
      answer: "No. The Networking Salon is a curated membership community. Interested individuals must apply to join. If approved, you'll receive details regarding membership plans and payment.",
      hasButton: true
    }, {
      question: 'What is the membership application process?',
      answer: <div data-id="element-1371">
              <p data-id="element-1372">The process is simple:</p>
              <ul className="list-disc list-inside mt-2 space-y-1" data-id="element-1373">
                <li data-id="element-1374">
                  <strong data-id="element-1375">Apply</strong> → Submit an application form.
                </li>
                <li data-id="element-1376">
                  <strong data-id="element-1377">Review</strong> → Our team evaluates your fit with the
                  community's vision.
                </li>
                <li data-id="element-1378">
                  <strong data-id="element-1379">Approval</strong> → If approved, you'll receive
                  membership details.
                </li>
                <li data-id="element-1380">
                  <strong data-id="element-1381">Payment</strong> → Secure your spot by completing
                  payment.
                </li>
                <li data-id="element-1382">
                  <strong data-id="element-1383">Onboarding</strong> → Get access to resources, the
                  directory, and events.
                </li>
              </ul>
            </div>,
      hasButton: true
    }, {
      question: 'What kind of resources do you offer?',
      answer: <div data-id="element-1384">
              <p data-id="element-1385">We've built practical, ready-to-use resources, including:</p>
              <ul className="list-disc list-inside mt-2 space-y-1" data-id="element-1386">
                <li data-id="element-1387">
                  🚀 LinkedIn Optimization Checklist – strengthen your
                  professional visibility.
                </li>
                <li data-id="element-1388">
                  🤝 Networking Scripts & Templates – easy outreach and
                  follow-up examples.
                </li>
                <li data-id="element-1389">
                  🌏 Opportunity Tracker – keep tabs on grants, fellowships, and
                  funding.
                </li>
                <li data-id="element-1390">
                  🎙 Podcast Starter List – curated content to sharpen skills
                  and mindset.
                </li>
                <li data-id="element-1391">
                  ❤️ Community Culture Tools – frameworks for collaboration and
                  mentorship.
                </li>
                <li data-id="element-1392">
                  📒 Community Directory – connect with members based on skills
                  and interests.
                </li>
              </ul>
            </div>
    }]
  }, {
    title: '✨ For New Members',
    questions: [{
      question: 'How do I get started once I join?',
      answer: <ul className="list-disc list-inside space-y-1" data-id="element-1393">
              <li data-id="element-1394">Complete your member profile in the Community Directory.</li>
              <li data-id="element-1395">
                Explore the Networking Guide to design your networking approach.
              </li>
              <li data-id="element-1396">Check the Opportunity Tracker and Scholarship Database.</li>
              <li data-id="element-1397">
                Attend an onboarding session (virtual) to meet other new
                members.
              </li>
            </ul>
    }, {
      question: 'How do I connect with other members?',
      answer: <div data-id="element-1398">
              <p data-id="element-1399">You can connect through:</p>
              <ul className="list-disc list-inside mt-2 space-y-1" data-id="element-1400">
                <li data-id="element-1401">
                  The Community Directory (searchable by skills, interests, and
                  location).
                </li>
                <li data-id="element-1402">
                  Peer-to-peer Networking Sessions (scheduled via Calendly).
                </li>
                <li data-id="element-1403">Collaboration Playbooks and group projects.</li>
                <li data-id="element-1404">Events, both virtual and in-person.</li>
              </ul>
            </div>
    }, {
      question: "I'm new to networking. Where should I start?",
      answer: <div data-id="element-1405">
              <p data-id="element-1406">
                Start with our Networking Guide — an interactive workbook that
                helps you design your own approach, build confidence, and track
                progress. Pair it with the Networking Scripts to make first
                outreach easier.
              </p>
              <div className="mt-4" data-id="element-1407">
                <Link to="/networking-guide" data-id="element-1408">
                  <Button variant="outline" data-id="element-1409">View Networking Guide</Button>
                </Link>
              </div>
            </div>
    }]
  }, {
    title: '🌱 For Active Members',
    questions: [{
      question: 'How do I use the Notion templates?',
      answer: "We provide shareable Notion templates that you can duplicate into your own workspace with a single click. You'll find trackers, databases, and interactive workbooks (like the Networking Guide)."
    }, {
      question: 'Can I contribute resources to the community?',
      answer: 'Yes! We welcome member contributions — from opportunities, guides, and case studies to hosting workshops. Collaboration is at the heart of the Networking Salon.'
    }, {
      question: 'Do you host events?',
      answer: 'Yes! We organize virtual meetups, workshops, and city-based gatherings (e.g., Lagos, Abuja, Berlin, Benin City, Delta). Members can also host their own events through our collaboration framework.'
    }, {
      question: 'How do I stay updated?',
      answer: <ul className="list-disc list-inside space-y-1" data-id="element-1410">
              <li data-id="element-1411">Subscribe to our community mailing list.</li>
              <li data-id="element-1412">Check the Opportunity Tracker regularly.</li>
              <li data-id="element-1413">Follow updates inside the community hub.</li>
            </ul>
    }]
  }];
  return <div className="pt-20" data-id="element-1414">
      <section className="py-16 bg-secondary/5" data-id="element-1415">
        <div className="container mx-auto px-4" data-id="element-1416">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-1417">
            ❓ Frequently Asked Questions (FAQ)
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-1418">
            Find answers to common questions about The Networking Salon,
            membership, and how to make the most of our community.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-1419">
        <div className="container mx-auto px-4" data-id="element-1420">
          <div className="space-y-12" data-id="element-1421">
            {faqSections.map((section, sectionIndex) => <div key={sectionIndex} data-id="element-1422">
                <h2 className="text-2xl font-bold text-secondary-dark mb-6" data-id="element-1423">
                  {section.title}
                </h2>
                <div className="space-y-6" data-id="element-1424">
                  {section.questions.map((faq, faqIndex) => <Card key={faqIndex} className="p-6" data-id="element-1425">
                      <h3 className="text-xl font-bold text-secondary-dark mb-3" data-id="element-1426">
                        {faqIndex + 1}. {faq.question}
                      </h3>
                      <div className="text-secondary" data-id="element-1427">{faq.answer}</div>
                      {faq.hasButton && <div className="mt-4" data-id="element-1428">
                          <Button onClick={openRegistrationForm} data-id="element-1429">
                            Apply Now
                          </Button>
                        </div>}
                    </Card>)}
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
};